import { combineReducers } from 'redux';
export default combineReducers({
    close_z3k_settings: (state = false, action) => {
        switch (action.type) {
            case 'CLOSE_Z3K_SETTINGS':
                return true;
            case 'UNCLOSE_Z3K_SETTINGS':
                return false;
            default:
                return state;
        }
    },
    open: (state = false, action) => {
        switch (action.type) {
            case 'OPEN_UPGRADE_DIALOG':
                return true;
            case 'CLOSE_UPGRADE_DIALOG':
                return false;
            default:
                return state;
        }
    },
    open_message: (state = { show: false, title: '', message: '' }, action) => {
        switch (action.type) {
            case 'OPEN_MESSAGE':
                return {
                    show: true,
                    title: action.content.title,
                    message: action.content.message,
                };
            case 'CLOSE_MESSAGE':
                return { ...state, show: false };
            default:
                return state;
        }
    },
    open_message_beta: (state = false, action) => {
        switch (action.type) {
            case 'OPEN_MESSAGE_BETA':
                return true;
            case 'CLOSE_MESSAGE_BETA':
                return false;
            default:
                return state;
        }
    },
    open_message_downgrade: (state = false, action) => {
        switch (action.type) {
            case 'OPEN_MESSAGE_DOWNGRADE':
                return true;
            case 'CLOSE_MESSAGE_DOWNGRADE':
                return false;
            default:
                return state;
        }
    },
    slow_mode: (state = false, action) => {
        switch (action.type) {
            case 'SLOW_MODE':
                return action.slow_mode;
            default:
                return state;
        }
    },
    firmware_releases: (state = {
        releases: [],
        changelogs: [],
        is_loading: false,
    }, action) => {
        switch (action.type) {
            case 'FIRMWARE_RELEASES':
                return {
                    ...state,
                    releases: action.releases,
                    changelogs: action.changelogs,
                };
            case 'FIRMWARE_RELEASES_LOADING':
                return { ...state, is_loading: action.is_loading };
            default:
                return state;
        }
    },
    select_release: (state = null, action) => {
        switch (action.type) {
            case 'SELECT_RELEASE':
                return {
                    release: action.release,
                    not_upgrade_beta: action.not_upgrade_beta,
                    not_upgrade_downgrade: action.not_upgrade_downgrade,
                };
            case 'UPGRADE_MESSAGE':
                if (!state)
                    return null;
                return {
                    release: state.release,
                    not_upgrade_beta: action.beta,
                    not_upgrade_downgrade: action.downgrade,
                };
            default:
                return state;
        }
    },
    manual_upgrade: (state = {
        firmware: null,
        profile: null,
        not_reboot: false,
        is_loading: false,
    }, action) => {
        switch (action.type) {
            case 'SELECT_FILE': {
                const { file, name } = action.file;
                return { ...state, [name]: file };
            }
            case 'NOT_REBOOT':
                return { ...state, not_reboot: !state.not_reboot };
            case 'IS_LOADING':
                return { ...state, is_loading: action.is_loading };
            default:
                return state;
        }
    },
    upload: (state = {
        files: [],
        prefix: '',
        is_loading: false,
    }, action) => {
        switch (action.type) {
            case 'SELECT_FILE_UPLOAD': {
                const newFiles = state.files;
                for (const file of action.files) {
                    if (!newFiles.some((statefile) => statefile.name === file.name))
                        newFiles.push(file);
                }
                return { ...state, files: newFiles };
            }
            case 'PREFIX':
                return { ...state, prefix: action.prefix };
            case 'IS_LOADING_UPLOAD':
                return { ...state, is_loading: action.is_loading };
            case 'REMOVE_FILE': {
                return {
                    ...state,
                    files: state.files.filter((file) => file.name !== action.fileName),
                };
            }
            default:
                return state;
        }
    },
});
